import { render, staticRenderFns } from "./fund.vue?vue&type=template&id=65948204&scoped=true&"
import script from "./fund.vue?vue&type=script&lang=js&"
export * from "./fund.vue?vue&type=script&lang=js&"
import style0 from "./fund.vue?vue&type=style&index=0&id=65948204&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65948204",
  null
  
)

export default component.exports